/* Axios request config that keeps the shared 403 interceptor from reloading the SPA: for a
   read whose caller draws its own denied/error state, a reload only churns the page. */
export const SKIP_FORBIDDEN_RESPONSE_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const HTTP_RESPONSE_STATUS_CODES = {
  SUCCESS: 200,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_ACCEPTABLE: 406,
  METHOD_NOT_ALLOWED: 405,
  NOT_FOUND: 404,
  GONE: 410,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  LOAN_FEES_ERROR: 419,
  TOO_MANY_REQUESTS: 429,
  LOAN_VALIDATION_ERROR: 432,
  LOAN_SEND_DISCLOSURE: 433,
  NO_CREDIT_REPORT: 434,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
};

export const CONFLICT_TYPE = {
  DEFAULT: 'Default',
  INVALID_USER_LICENSE_STATE: 'InvalidUserLicenseState',
  INVALID_LOAN_PROGRAM: 'InvalidLoanProgram',
  LOCK_EXTENSION_LIMIT_EXCEEDED: 'LoanLockExtensionLimitExceeded',
  CLOSING_DISCLOSURE_IS_BEING_WORKED_ON: 'ClosingDisclosureIsBeingWorkedOn',
};

export const HTTP_METHOD = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'delete',
  HEAD: 'head',
  OPTIONS: 'options',
};
